import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.75} y={0.75} width={34.5} height={22.5} fill="white" />
      <path
        d="M21.2959 18.0777H14.8711V6.60352H21.2959V18.0777Z"
        fill="#FF5F00"
      />
      <path
        d="M15.2829 12.3394C15.2829 10.0118 16.3796 7.9384 18.0874 6.60225C16.8385 5.62519 15.2624 5.04201 13.5494 5.04201C9.49424 5.04201 6.20703 8.30909 6.20703 12.3394C6.20703 16.3696 9.49424 19.6367 13.5494 19.6367C15.2624 19.6367 16.8385 19.0535 18.0874 18.0765C16.3796 16.7403 15.2829 14.667 15.2829 12.3394"
        fill="#EB001B"
      />
      <path
        d="M29.9609 12.3394C29.9609 16.3696 26.6737 19.6367 22.6185 19.6367C20.9056 19.6367 19.3294 19.0535 18.0801 18.0765C19.7883 16.7403 20.885 14.667 20.885 12.3394C20.885 10.0118 19.7883 7.9384 18.0801 6.60225C19.3294 5.62519 20.9056 5.04201 22.6185 5.04201C26.6737 5.04201 29.9609 8.30909 29.9609 12.3394"
        fill="#F79E1B"
      />
      <rect
        x={0.75}
        y={0.75}
        width={34.5}
        height={22.5}
        stroke="#CBD5E1"
        strokeWidth={1.5}
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-mastercard" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
